import PropTypes from "prop-types";
import React from "react";

// @material-ui/core components
import { withStyles } from "@mui/styles";
import { Card, CardBody, Button, GridContainer, GridItem } from "~/shared/components/MuiComponents.jsx";

import consultationStyles from "../styles/consultationStyles.js";

import { trackVisitProductSelected } from "../utils/analytics.js";

import imgOnePack from "~assets/images/visits/one-pack.png";
import imgTwoPack from "~assets/images/visits/two-pack.png";

import {
  getVisitID,
  getVisitProduct,
  isFollowUpVisit,
  setConsultationTypeOrderItem,
  setVisitProduct,
} from "~/visits/utils/visitCookies";

import {
  COLOR_KICK_BLUE,
  ORDER_TYPE_ATE_SCO_1_PACK,
  ORDER_TYPE_ATE_SCO_1_PACK_FOLLOW_UP,
  ORDER_TYPE_ATE_SCO_1_PACK_REFILL,
  ORDER_TYPE_ATE_SCO_2_PACK,
  ORDER_TYPE_ATE_SCO_2_PACK_FOLLOW_UP,
  ORDER_TYPE_ATE_SCO_2_PACK_REFILL,
  PRICE_ATE_SCO_1_PACK,
  PRICE_ATE_SCO_1_PACK_FOLLOW_UP,
  PRICE_ATE_SCO_1_PACK_REFILL,
  PRICE_ATE_SCO_2_PACK,
  PRICE_ATE_SCO_2_PACK_FOLLOW_UP,
  PRICE_ATE_SCO_2_PACK_REFILL,
} from "~/shared/sharedConstants.js";

import { kickBlue, kickNavy, kickRed } from "~/shared/styles/baseStyles";

class SelectGAProduct extends React.Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(this.props.location.search);
    const checkoutSessionID = queryParams.get("checkoutSessionID");
    this.state = {
      consultationType: this.props.match.params.consultationType,
      checkoutSessionID,
      selectedProduct: getVisitProduct(checkoutSessionID) || "",
      showError: false,
    };

    if (!checkoutSessionID || !getVisitID(checkoutSessionID)) {
      window.location.href = "/me/portal";
    }
  }

  getGAProductPrice = (orderType) => {
    switch (orderType) {
      case ORDER_TYPE_ATE_SCO_1_PACK:
        return `$${PRICE_ATE_SCO_1_PACK}`;
      case ORDER_TYPE_ATE_SCO_1_PACK_FOLLOW_UP:
        return `$${PRICE_ATE_SCO_1_PACK_FOLLOW_UP}`;
      case ORDER_TYPE_ATE_SCO_1_PACK_REFILL:
        return `$${PRICE_ATE_SCO_1_PACK_REFILL}`;
      case ORDER_TYPE_ATE_SCO_2_PACK:
        return `$${PRICE_ATE_SCO_2_PACK}`;
      case ORDER_TYPE_ATE_SCO_2_PACK_FOLLOW_UP:
        return `$${PRICE_ATE_SCO_2_PACK_FOLLOW_UP}`;
      case ORDER_TYPE_ATE_SCO_2_PACK_REFILL:
        return `$${PRICE_ATE_SCO_2_PACK_REFILL}`;
      default:
        return "$0";
    }
  };

  handleSelection = (selectedProduct) => {
    let modifiedProduct = selectedProduct;

    if (isFollowUpVisit(this.state.checkoutSessionID)) {
      const currentProduct = getVisitProduct(this.state.checkoutSessionID);
      const isRefill = currentProduct && currentProduct.includes("refill");

      switch (selectedProduct) {
        case ORDER_TYPE_ATE_SCO_2_PACK:
          modifiedProduct = isRefill
            ? ORDER_TYPE_ATE_SCO_2_PACK_REFILL
            : ORDER_TYPE_ATE_SCO_2_PACK_FOLLOW_UP;
          break;

        case ORDER_TYPE_ATE_SCO_1_PACK:
          modifiedProduct = isRefill
            ? ORDER_TYPE_ATE_SCO_1_PACK_REFILL
            : ORDER_TYPE_ATE_SCO_1_PACK_FOLLOW_UP;
          break;
      }
    }

    this.setState({ selectedProduct: modifiedProduct, showError: false });
    setVisitProduct(modifiedProduct, this.state.checkoutSessionID);
    setConsultationTypeOrderItem(
      this.state.consultationType,
      modifiedProduct,
      this.state.checkoutSessionID,
    );
  };

  nextQuestion = () => {
    if (!this.state.selectedProduct) {
      this.setState({ showError: true });
      return;
    }

    setConsultationTypeOrderItem(
      this.state.consultationType,
      this.state.selectedProduct,
      this.state.checkoutSessionID,
    );

    // Navigate to GA flavor selection
    this.props.history.push(
      `/visits/${this.state.consultationType}/select-ga-flavored?checkoutSessionID=${this.state.checkoutSessionID}`,
    );
    window.scrollTo(0, 0);
  };

  isSelected = (productType) => {
    const selected = this.state.selectedProduct;

    // For 2-pack selection
    if (productType === ORDER_TYPE_ATE_SCO_2_PACK) {
      return (
        selected === ORDER_TYPE_ATE_SCO_2_PACK ||
        selected === ORDER_TYPE_ATE_SCO_2_PACK_FOLLOW_UP ||
        selected === ORDER_TYPE_ATE_SCO_2_PACK_REFILL
      );
    }

    // For 1-pack selection
    if (productType === ORDER_TYPE_ATE_SCO_1_PACK) {
      return (
        selected === ORDER_TYPE_ATE_SCO_1_PACK ||
        selected === ORDER_TYPE_ATE_SCO_1_PACK_FOLLOW_UP ||
        selected === ORDER_TYPE_ATE_SCO_1_PACK_REFILL
      );
    }

    return false;
  };

  getCurrentPrice = (baseOrderType) => {
    if (isFollowUpVisit(this.state.checkoutSessionID)) {
      const currentProduct = getVisitProduct(this.state.checkoutSessionID);
      const isRefill = currentProduct && currentProduct.includes("refill");

      if (baseOrderType === ORDER_TYPE_ATE_SCO_2_PACK) {
        return isRefill
          ? PRICE_ATE_SCO_2_PACK_REFILL
          : PRICE_ATE_SCO_2_PACK_FOLLOW_UP;
      } else {
        return isRefill
          ? PRICE_ATE_SCO_1_PACK_REFILL
          : PRICE_ATE_SCO_1_PACK_FOLLOW_UP;
      }
    }

    return baseOrderType === ORDER_TYPE_ATE_SCO_2_PACK
      ? PRICE_ATE_SCO_2_PACK
      : PRICE_ATE_SCO_1_PACK;
  };

  render() {
    const { classes } = this.props;

    return (
      <div
        className={classes.container}
        style={{ backgroundColor: COLOR_KICK_BLUE }}
      >
        <GridContainer justifyContent="center">
          <GridItem xs={10} sm={10} md={8}>
            <h3
              style={{
                color: "#FFFFFF",
                fontFamily: "Spectral-SemiBold",
                fontSize: "32px",
                marginTop: "40px",
              }}
            >
              How many packs would you like?
            </h3>
            <p
              style={{
                color: "#FFFFFF",
                fontFamily: "BasisGrotesquePro-Regular",
                fontSize: "18px",
                lineHeight: "26px",
              }}
            >
              Your Atenolol + Scopolamine combination comes in fast-acting
              lozenges. Select the quantity that works best for you.
              <br />
            </p>
          </GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <Card className={classes.cardConsultation}>
              <CardBody
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "0 2px",
                }}
              >
                <div
                  className={classes.selectBBProductWrapper}
                  style={{
                    overflow: "hidden",
                    backgroundColor: this.isSelected(ORDER_TYPE_ATE_SCO_2_PACK)
                      ? "#fff7e5"
                      : "",
                  }}
                  onClick={() =>
                    this.handleSelection(ORDER_TYPE_ATE_SCO_2_PACK)
                  }
                >
                  <img
                    className="imgTwoPack"
                    src={imgTwoPack}
                    style={{
                      height: "fit-content",
                      position: "relative",
                      marginBottom: "10px",
                    }}
                    alt="Double Pack Atenolol + Scopolamine (48 tablets)"
                  />
                  <div className={classes.selectBBProductTwoPackWrapper}>
                    <h4
                      className={classes.selectBBProductImageTitle}
                      style={{
                        marginBottom: 0,
                        color: kickBlue,
                        fontWeight: "bold",
                      }}
                    >
                      Two Packs Atenolol + Scopolamine (48 Tablets)
                    </h4>
                    <p
                      style={{
                        fontSize: "16px",
                        color: kickRed,
                        fontWeight: this.isSelected(ORDER_TYPE_ATE_SCO_2_PACK)
                          ? "bold"
                          : "",
                      }}
                    >
                      ${this.getCurrentPrice(ORDER_TYPE_ATE_SCO_2_PACK)} -
                      Medication with FREE Shipping
                      <br />
                      <span
                        style={{
                          fontSize: "15px",
                          color: kickNavy,
                        }}
                      >
                        {" "}
                        Most Popular Option
                      </span>
                    </p>

                    <ul
                      style={{
                        fontSize: "18px",
                        color: kickNavy,
                        lineHeight: "140%",
                      }}
                    >
                      <li style={{ paddingBottom: "2px" }}>
                        Always be prepared with a pack at home and another at
                        work.
                      </li>
                      <li style={{ paddingBottom: "2px" }}>
                        Two-pack refills without needing a new prescription.
                      </li>
                      <li style={{ paddingBottom: "2px" }}>
                        Your order lasts longer, so you can refill less often.
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  style={{
                    height: "1px",
                    margin: "0 100px",
                    backgroundColor: COLOR_KICK_BLUE,
                  }}
                />

                <div
                  className={classes.selectBBProductWrapper}
                  style={{
                    backgroundColor: this.isSelected(ORDER_TYPE_ATE_SCO_1_PACK)
                      ? "#fff7e5"
                      : "",
                  }}
                  onClick={() =>
                    this.handleSelection(ORDER_TYPE_ATE_SCO_1_PACK)
                  }
                >
                  <img
                    src={imgOnePack}
                    style={{
                      height: "fit-content",
                      marginBottom: "10px",
                      position: "relative",
                    }}
                    alt="Single Pack Atenolol + Scopolamine Tablets"
                  />
                  <h4
                    className={classes.selectBBProductImageTitleLower}
                    style={{
                      fontWeight: this.isSelected(ORDER_TYPE_ATE_SCO_1_PACK)
                        ? "bold"
                        : "",
                    }}
                  >
                    One Pack Atenolol + Scopolamine (24 tablets)
                    <br />
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: this.isSelected(ORDER_TYPE_ATE_SCO_1_PACK)
                          ? "bold"
                          : "",
                      }}
                    >
                      ${this.getCurrentPrice(ORDER_TYPE_ATE_SCO_1_PACK)} —
                      Medication with FREE Shipping
                    </p>
                  </h4>
                </div>
              </CardBody>
            </Card>
            <div style={{ color: "red", margin: "20px auto 6px auto" }}>
              <p style={{ textAlign: "center" }}>
                {this.state.showError ? "Please select an option above" : ""}
              </p>
            </div>
            <Button
              onClick={() => {
                trackVisitProductSelected(
                  getVisitID(this.state.checkoutSessionID),
                  this.state.selectedProduct,
                );
                this.nextQuestion();
              }}
              style={{
                display: "block",
                backgroundColor: "#F25930",
                margin: "4px auto 30px auto",
                width: "300px",
                fontSize: "18px",
                fontWeight: "medium",
                textTransform: "unset",
              }}
            >
              Continue
            </Button>
          </GridItem>
        </GridContainer>
      </div>
    );
  }

  componentDidMount() {
    this.visitIDCheckPoller = setInterval(() => {
      if (!getVisitID(this.state.checkoutSessionID)) {
        window.location.href = "/me/portal";
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.visitIDCheckPoller);
  }
}

SelectGAProduct.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(consultationStyles)(SelectGAProduct);
